const L = (t) =>
    t ? ((t = t.toString()), t.charAt(0).toUpperCase() + t.slice(1)) : "",
  U = (t) => ((t = t.toLowerCase()), t.charAt(0).toUpperCase() + t.slice(1)),
  $ = (t) => t.toUpperCase(),
  q = (t) => t.replace(/ +/g, ""),
  P = (t, e) =>
    t == null
      ? void 0
      : t
          .replace(
            /_(pico|16x16|icon|32x32|thumb|50x50|small|100x100|compact|160x160|medium|240x240|large|480x480|grande|600x600|original|1024x1024|2048x2048|master)+\./g,
            ".",
          )
          .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (s) => `_${e}${s}`),
  Psrcset = (t, widths) => {
    if (t == null) return void 0;
    const base = t.replace(/_(pico|16x16|icon|32x32|thumb|50x50|small|100x100|compact|160x160|medium|240x240|large|480x480|grande|600x600|original|1024x1024|2048x2048|master)+\./g, ".");
    return (widths || [400, 800, 1200, 1600, 2000])
      .map((w) => `${base.replace(/\.jpg|\.png|\.gif|\.jpeg/g, (s) => `_${w}x${s}`)} ${w}w`)
      .join(", ");
  },
  A = (t, e) => {
    if (typeof e == "number") return e > 1 ? `${t}s` : t;
    if (Array.isArray(e)) return e.length > 1 ? `${t}s` : t;
  },
  I = (t) => t.split(" - ")[0],
  M = (t) => t.split(" - ")[1],
  N = (t) =>
    t
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, ""),
  O = (t = 16) => {
    const e = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
      s = e.length,
      i = [];
    for (let o = 0; o < t; o++) i.push(e.charAt(Math.floor(Math.random() * s)));
    return i.join("");
  },
  z = (t) => {
    var e;
    return ((e = t.split("/").pop()) == null ? void 0 : e.split("?")[0]) ?? "";
  },
  T = (t, e) => {
    typeof t == "string" && (t = t.replace(".", ""));
    let s = "";
    const i = /\{\{\s*(\w+)\s*\}\}/,
      o = e || Theme.shop.money_format;
    function r(a, c, l = ",", h = ".") {
      if (isNaN(a) || a == null) return "0";
      const m = (a / 100).toFixed(c).split("."),
        k = m[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + l);
      let _ = m[1] ? h + m[1] : "";
      return (_ === ".00" && (_ = ""), k + _);
    }
    const n = o.match(i);
    if (n)
      switch (n[1]) {
        case "amount":
          s = r(Number(t), Number(t) % 100 === 0 ? 0 : 2);
          break;
        case "amount_no_decimals":
          s = r(Number(t), 0);
          break;
        case "amount_with_comma_separator":
          s = r(Number(t), Number(t) % 100 === 0 ? 0 : 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = r(Number(t), 0, ".", ",");
          break;
      }
    return o.replace(i, s);
  },
  V = T,
  j = (t) => (
    (t = (t + "").replace(/[^\d.-]/g, "")),
    t && t.includes(".") && (t = t.substring(0, t.indexOf(".") + 3)),
    t ? Math.round(parseFloat(t) * 100) : 0
  ),
  R = (t, e) => {
    const s = [];
    function i(r, n) {
      const a = n ?? "";
      s.push(encodeURIComponent(r) + "=" + encodeURIComponent(a));
    }
    function o(r, n) {
      if (Array.isArray(n))
        n.forEach((a, c) => {
          /\[\]$/.test(r)
            ? i(r, a)
            : o(r + "[" + (typeof a == "object" && a ? c : "") + "]", a);
        });
      else if (typeof n == "object")
        for (let a in n) n.hasOwnProperty(a) && o(r + "[" + a + "]", n[a]);
      else i(r, n);
    }
    if (Array.isArray(t))
      t.forEach((r, n) => {
        o(e + "[" + n + "]", r);
      });
    else
      for (let r in t)
        t.hasOwnProperty(r) && o(e ? e + "[" + r + "]" : r, t[r]);
    return s.join("&");
  },
  d = new Map(),
  f = new Map(),
  E = async (t, e = {}, s = {}) => {
    if (!t) return { data: null, error: "No URL provided" };
    const i = new URLSearchParams(t.includes("?") ? t.split("?")[1] : "");
    Object.entries(e).forEach(([r, n]) =>
      Array.isArray(n)
        ? n.forEach((a) => i.append(r, typeof a == "number" ? a.toString() : a))
        : i.set(r, typeof n == "number" ? n.toString() : n),
    );
    const o = `${t.split("?")[0]}?${i.toString()}`;
    if (f.has(o)) return { data: f.get(o), error: null };
    if (d.has(o)) return d.get(o);
    try {
      const r = window
        .fetch(o, s)
        .then((n) => {
          if (!n.ok) throw new Error(`HTTP error! status: ${n.status}`);
          return n.json();
        })
        .then((n) => (f.set(o, n), d.delete(o), { data: n, error: null }))
        .catch(
          (n) => (
            d.delete(o),
            console.error("Fetch error:", n.message),
            {
              data: null,
              error: n instanceof Error ? n.message : "Fetch error",
            }
          ),
        );
      return (d.set(o, r), await r);
    } catch (r) {
      return (
        d.delete(o),
        console.error("Fetch error:", r instanceof Error ? r.message : r),
        { data: null, error: r instanceof Error ? r.message : "Fetch error" }
      );
    }
  },
  D = async (t, e = {}, s = {}) => {
    if (!t) return { data: null, error: "No URL provided" };
    const i = new URLSearchParams(t.includes("?") ? t.split("?")[1] : "");
    Object.entries(e).forEach(([r, n]) =>
      Array.isArray(n) ? n.forEach((a) => i.append(r, a)) : i.set(r, n),
    );
    const o = `${t.split("?")[0]}?${i.toString()}`;
    try {
      const r = await window.fetch(o, s);
      if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
      return { data: await r.json(), error: null };
    } catch (r) {
      return (
        console.error("Fetch error:", r instanceof Error ? r.message : r),
        { data: null, error: r instanceof Error ? r.message : "Fetch error" }
      );
    }
  },
  H = async (t, e = {}) => {
    try {
      const s = await window.fetch(t, { method: "POST", ...e });
      if (!s.ok) throw new Error(`HTTP error! status: ${s.status}`);
      return { data: await s.json(), error: null };
    } catch (s) {
      return (
        console.error("Post error:", s instanceof Error ? s.message : s),
        { data: null, error: s instanceof Error ? s.message : s }
      );
    }
  },
  Q = ({ url: t, cache: e = !0 }) =>
    new Promise((s, i) => {
      const o = document.createElement("script");
      ((o.src = t),
        e ||
          (o.src +=
            (o.src.includes("?") ? "&" : "?") + "_=" + new Date().getTime()),
        (o.onload = () => {
          s();
        }),
        (o.onerror = (r) => {
          i(r);
        }),
        document.head.appendChild(o));
    }),
  p = new Map(),
  F = new Date().getTime(),
  W = async (t, { cache: e = !0, bust: s = F, type: i = "module" }) => {
    if (!t) return console.error("loadScript: No URL provided");
    const o = e ? t : `${t}${t.includes("?") ? "&" : "?"}_=${s}`,
      r = p.get(o);
    if (!(r && r.loaded)) {
      if (d.has(o)) return d.get(o);
      try {
        const n = new Promise((a, c) => {
          const l = document.createElement("script");
          ((l.src = o),
            (l.type = i),
            p.set(o, { loading: !0, loaded: !1 }),
            (l.onload = () => {
              (p.set(o, { loading: !1, loaded: !0 }), d.delete(o), a());
            }),
            (l.onerror = (h) => {
              (p.set(o, { loading: !1, loaded: !1 }), d.delete(o), c());
            }),
            document.head.appendChild(l));
        });

        return (d.set(o, n), await n);
      } catch (n) {
        return (
          d.delete(o),
          console.error(
            "Script load error:",
            n instanceof Error ? n.message : n,
          )
        );
      }
    }
  },
  B = (t) => new URLSearchParams(window.location.search).get(t),
  J = (t) => {
    const e = new Set();
    (document.querySelectorAll(`${t}`).forEach((s) => {
      const i = s.closest("[data-vue-parent]");
      i && e.add(i);
    }),
      e.forEach((s) => {
        var o;
        const i = s.__vue__;
        (o = i == null ? void 0 : i.$forceUpdate) == null || o.call(i);
      }));
  },
  K = async ({ sid: t, exclude: e, origin: s }) => {
    if (!t)
      return (
        console.error("fetchColorways: sid is required"),
        { colorways: null, error: "sid is required" }
      );
    const { data: i, error: o } = await E(`/collections/all/sid:${t}`, {
      view: "json",
      sort_by: "created-descending",
    });
    if (o || !i)
      return (
        console.error(
          "fetchColorways: fetch error",
          o ?? "No colorways data found",
        ),
        { colorways: null, error: o ?? "No colorways data found" }
      );
    let r = i.products;
    return (
      e
        ? (r = r.filter((n) => n.id !== e))
        : s && (r = r.sort((n, a) => (n.id == s ? -1 : a.id == s ? 1 : 0))),
      { colorways: r, error: null }
    );
  },
  Y = async ({ handle: t }) => {
    if (!t)
      return (
        console.error("fetchProduct: handle is required"),
        { product: null, error: "handle is required" }
      );
    const { data: e, error: s } = await E(`/products/${t}`, { view: "json" });
    return s
      ? (console.error("fetchProduct: Shopify fetch error", s),
        { product: null, error: s })
      : e
        ? { product: e, error: null }
        : (console.error("fetchProduct: No product data found in response"),
          { product: null, error: "No product data found" });
  },
  G = (t) => {
    if (!t) return;
    const e = document.querySelector("my-modal[name='product-quick-view']");
    if (
      document.startViewTransition &&
      window.MQ["from-desktop"].matches &&
      e &&
      !e.hasAttribute("open")
    ) {
      const s = t.querySelector("img[data-vt='pimg-1']"),
        i = e.querySelector("my-vt img[data-vt='pimg-1']"),
        o = s.src ?? s.getAttribute("data-src");
      if (!s || !i || !o) return;
      ((s.style.viewTransitionName = s.getAttribute("data-vt") ?? ""),
        (s.style.viewTransitionClass = "pvt"),
        document
          .startViewTransition(() => {
            ((s.style.viewTransitionName = ""),
              (s.style.viewTransitionClass = ""),
              e.setAttribute("data-vt-state", "running"),
              (i.style.viewTransitionName = i.getAttribute("data-vt") ?? ""),
              (i.style.viewTransitionClass = "pvt"),
              (i.src = o));
          })
          .finished.finally(() => {
            ((i.style.viewTransitionName = ""),
              (i.style.viewTransitionClass = ""),
              e.setAttribute("data-vt-state", "finished"));
          }));
    }
  },
  X = (t, e) =>
    Array.from({ length: Math.ceil(t.length / e) }, (s, i) =>
      t.slice(i * e, i * e + e),
    ),
  Z = (t, e = null) => {
    try {
      return JSON.parse(t);
    } catch (s) {
      return (console.error("Error parsing JSON:", s), e);
    }
  },
  tt = (t) => t % 2 == 0,
  et = (t) => Math.abs(t % 2) == 1,
  C = () => {
    const t = navigator.userAgent || navigator.vendor;
    return t.indexOf("Instagram") > -1
      ? "instagram"
      : t.indexOf("Firefox") > -1
        ? "firefox"
        : t.indexOf("Chrome") > -1
          ? "chrome"
          : t.indexOf("Safari") > -1
            ? "safari"
            : t.indexOf("Opera") > -1
              ? "opera"
              : t.indexOf("MSIE") > -1 || t.indexOf("Trident") > -1
                ? "ie"
                : t.indexOf("Edge") > -1
                  ? "edge"
                  : null;
  },
  b = C();
b && document.documentElement.setAttribute("data-browser", b);
const st = (t, e, s) => {
    let i;
    return function () {
      const o = this,
        r = arguments,
        n = function () {
          ((i = null), s || t.apply(o, r));
        },
        a = s && !i;
      (clearTimeout(i), (i = setTimeout(n, e)), a && t.apply(o, r));
    };
  },
  it = (t, e = {}) => {
    document.dispatchEvent(new CustomEvent(t, { detail: e }));
  },
  ot = {
    vue: (t, e, s) => {
      const i = document.querySelector(t);
      i && i.vue_instance
        ? s({ web_component: i, vue_instance: i.vue_instance })
        : document.addEventListener(`vue-created.vue-${e}`, (o) =>
            s({
              web_component: document.querySelector(t),
              vue_instance: o.detail.vue_instance,
            }),
          );
    },
    wc: (t, e, s) => {
      const i = document.querySelector(t);
      i && i.is_initialized
        ? s({ web_component: i })
        : document.addEventListener(`wc-init.${e}`, (o) =>
            s({ web_component: o.detail.element }),
          );
    },
  },
  rt = () => document.documentElement.classList.contains("dark"),
  nt = () => !document.documentElement.classList.contains("dark"),
  at = (t, e = null) => {
    try {
      const s = localStorage.getItem(t);
      if (s === null) return e;
      try {
        const i = JSON.parse(s);
        if (typeof i == "object" && i !== null) return i;
      } catch {}
      if (typeof e == "number") {
        const i = parseFloat(s);
        return isNaN(i) ? e : i;
      } else if (typeof e == "boolean") return s === "true";
      return s;
    } catch (s) {
      return (
        console.error(
          `Error retrieving item from localStorage for key "${t}":`,
          s,
        ),
        e
      );
    }
  },
  ct = ({ name: t, value: e, hours: s = 24 }) => {
    if (!t || !e) {
      console.error("setCookie: name and value are required");
      return;
    }
    s
      ? (document.cookie = `${t}=${encodeURIComponent(e)};expires=${new Date(Date.now() + s * 60 * 60 * 1e3).toUTCString()}; path=/`)
      : (document.cookie = `${t}=${encodeURIComponent(e)}; path=/`);
  },
  dt = (t) => {
    const e = document.cookie.match(`(?:^|; )${t}=([^;]*)`);
    return e ? decodeURIComponent(e[1]) : null;
  },
  lt = (t) => {
    document.cookie = `${t}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },
  u = ({ target: t, props: e }) => gsap.set(t, { clearProps: e }),
  ht = ({ target: t, to: e, clear: s }) => {
    const i = {
      opacity: 1,
      onComplete: () => {
        s && u({ target: t, props: "opacity,transition" });
      },
    };
    gsap.fromTo(t, { opacity: 0, transition: "none" }, { ...i, ...e });
  },
  ut = ({ target: t, to: e, clear: s }) => {
    const i = {
      opacity: 0,
      onComplete: () => {
        s && u({ target: t, props: "opacity,transition" });
      },
    };
    gsap.fromTo(t, { opacity: 1, transition: "none" }, { ...i, ...e });
  },
  mt = ({ target: t, from: e, to: s, clear: i }) => {
    const o = {
      opacity: 1,
      y: 0,
      onComplete: () => {
        i && u({ target: t, props: "opacity,transform,transition" });
      },
    };
    gsap.fromTo(
      t,
      { opacity: 0, y: typeof e < "u" ? e : 50, transition: "none" },
      { ...o, ...s },
    );
  },
  pt = ({ target: t, from: e, to: s, clear: i }) => {
    const o = {
      opacity: 1,
      y: 0,
      onComplete: () => {
        i && u({ target: t, props: "opacity,transform,transition" });
      },
    };
    gsap.fromTo(
      t,
      { opacity: 0, y: typeof e < "u" ? e : -50, transition: "none" },
      { ...o, ...s },
    );
  },
  ft = ({ target: t, from: e, to: s, clear: i }) => {
    const o = {
      opacity: 1,
      x: 0,
      onComplete: () => {
        i && u({ target: t, props: "opacity,transform,transition" });
      },
    };
    gsap.fromTo(
      t,
      { opacity: 0, x: typeof e < "u" ? e : 50, transition: "none" },
      { ...o, ...s },
    );
  },
  yt = ({ target: t, from: e, to: s, clear: i }) => {
    const o = {
      opacity: 1,
      x: 0,
      onComplete: () => {
        i && u({ target: t, props: "opacity,transform,transition" });
      },
    };
    gsap.fromTo(
      t,
      { opacity: 0, x: typeof e < "u" ? e : -50, transition: "none" },
      { ...o, ...s },
    );
  },
  _t = Object.freeze(
    Object.defineProperty(
      {
        __proto__: null,
        FETCH_CACHE: f,
        PENDING_REQUESTS: d,
        bridgify: ot,
        capitalize: L,
        capitalizeFirstLetter: U,
        chunk: X,
        clearProps: u,
        debounce: st,
        deleteCookie: lt,
        dispatchEvent: it,
        fadeDown: pt,
        fadeIn: ht,
        fadeLeft: ft,
        fadeOut: ut,
        fadeRight: yt,
        fadeUp: mt,
        fatche: E,
        fetch: D,
        fetchColorways: K,
        fetchProduct: Y,
        filename: z,
        forceUpdateParentVue: J,
        formatMoney: T,
        generateRandomId: O,
        getBrowserName: C,
        getCookie: dt,
        getFromLocalStorage: at,
        getScript: Q,
        getURLParameter: B,
        handleize: N,
        isDarkMode: rt,
        isEven: tt,
        isLightMode: nt,
        isOdd: et,
        loadScript: W,
        money: V,
        parseJSON: Z,
        pluralize: A,
        post: H,
        productColorname: M,
        productName: I,
        resizeImage: P,
        resizeImageSrcset: Psrcset,
        serializeParam: R,
        setCookie: ct,
        startViewTransitionPDP: G,
        toCents: j,
        unspace: q,
        upcase: $,
      },
      Symbol.toStringTag,
      { value: "Module" },
    ),
  );
window.Utils = _t;
document.addEventListener("lazybeforeunveil", async (t) => {
  const e = t.target,
    s = e.tagName.toLowerCase();
  if (/^(section-|my-|vue-|model-viewer)/.test(s)) {
    const i = e;
    if (i.dataset.libs) {
      const o = i.dataset.libs.split(",");
      try {
        (await Promise.all(
          o.map((r) => Utils.loadScript(Theme.assets[r], { cache: !0 })),
        ),
          Theme.debug && console.log(`lazyloaded libs: ${o.join(", ")}.`));
      } catch (r) {
        console.error(
          `Error lazyloading libs: ${o.join(", ")}`,
          r instanceof Error ? r.message : r,
        );
        return;
      }
    }
    try {
      (await Utils.loadScript(Theme.assets[s], { cache: !0 }),
        Theme.debug && console.log(`lazyloaded: ${s}.js and executed.`),
        i.init &&
          (i.init(),
          (i.is_initialized = !0),
          (i.dataset.loaded = "true"),
          Utils.dispatchEvent(`wc-init.${s}`, { element: i })));
    } catch (o) {
      console.error(
        `Error lazyloading ${s}`,
        o instanceof Error ? o.message : o,
      );
    }
  } else if (s === "video") {
    const i = e,
      o = i.getAttribute("data-src");
    if (!o) return;
    (i.setAttribute("src", o),
      (i.onloadeddata = () => {
        (i.play(),
          i.classList.remove("lazyloading"),
          i.classList.add("lazyloaded"));
      }));
  }
});
const v = {
  "till-desktop-lg": { media_query_string: "(max-width: 1439px)", matches: !1 },
  "from-desktop-lg": { media_query_string: "(min-width: 1440px)", matches: !1 },
  "till-desktop": { media_query_string: "(max-width: 1023px)", matches: !1 },
  "from-desktop": { media_query_string: "(min-width: 1024px)", matches: !1 },
  "till-tablet": { media_query_string: "(max-width: 767px)", matches: !1 },
  "from-tablet": { media_query_string: "(min-width: 768px)", matches: !1 },
  "till-phone": { media_query_string: "(max-width: 599px)", matches: !1 },
  "from-phone": { media_query_string: "(min-width: 600px)", matches: !1 },
  "is-touch-screen": { media_query_string: "(pointer: coarse)", matches: !1 },
  "is-mouse-screen": { media_query_string: "(pointer: fine)", matches: !1 },
};
window.MQ = v;
const x = () => {
  Object.keys(v).forEach((e) => {
    const s = v[e];
    s.matches = window.matchMedia(s.media_query_string).matches;
  });
};
x();
let g = null,
  w = !0;
new ResizeObserver(
  Utils.debounce(() => {
    g !== document.body.clientWidth &&
      ((g = document.body.clientWidth),
      x(),
      w && (w = !1),
      w || Utils.dispatchEvent("resize.width", { width: g }));
  }, 100),
).observe(document.body);
const gt = {
  editing_line_item: null,
  cart: window.Cart.cart,
  queue: [],
  processing: !1,
  openMiniCart(t = 300) {
    const e = document.querySelector("my-modal[name='minicart']"),
      s = document.querySelectorAll(
        "my-modal:not([name='minicart']):not([name='quick-search'])[open]",
      );
    s.length
      ? (s.forEach((i) => i.close()),
        e && !e.hasAttribute("open") && setTimeout(() => e.open(), t))
      : e && !e.hasAttribute("open") && e.open();
  },
  async processQueue() {
    if (!this.queue.length) {
      ((this.processing = !1),
        Utils.dispatchEvent("cart.request.complete", { cart: this.cart }),
        document.documentElement.removeAttribute("data-cart-loading"));
      return;
    }
    const t = this.queue.shift();
    if (t) {
      this.processing = !0;
      try {
        const e = await fetch(t.url, {
            method: t.method || "POST",
            headers: { "Content-Type": "application/json" },
            ...(t.method === "POST" && { body: JSON.stringify(t.payload) }),
          }),
          s = await e.json();
        if (e.ok) t.success && t.success(s);
        else throw s;
      } catch (e) {
        const s = e;
        (t.error && t.error({ message: s.message }),
          Utils.dispatchEvent("my.error", {
            error: s,
            message:
              (s == null ? void 0 : s.message) || "Please try again later.",
          }));
      } finally {
        (t.complete && t.complete(), this.processQueue());
      }
    }
  },
  addToQueue(t) {
    (this.queue.push(t),
      this.processing ||
        (Utils.dispatchEvent("cart.request.started", { cart: this.cart }),
        document.documentElement.setAttribute("data-cart-loading", ""),
        this.processQueue()));
  },
  async fetchCart() {
    const e = `/cart?${new URLSearchParams({ v: Date.now().toString(), view: "json" }).toString()}`;
    return new Promise((s, i) => {
      this.addToQueue({
        url: e,
        method: "GET",
        success: (o) => {
          s(o);
        },
        error: (o) => {
          (console.error(o), i(o));
        },
      });
    });
  },
  async revalidateCart() {
    const t = await this.fetchCart();
    return (
      (this.cart = t),
      Utils.dispatchEvent("cart.revalidated", { cart: t }),
      t
    );
  },
  addItem({
    id: t,
    quantity: e = 1,
    properties: s = {},
    success: i,
    error: o,
    complete: r,
    event: n,
  }) {
    let a = e;
    (this.editing_line_item &&
      ((a = this.editing_line_item.quantity),
      this.removeItem({
        line: this.editing_line_item.line,
        event: n,
        success: (c) => {
          this.editing_line_item = null;
        },
      })),
      this.addToQueue({
        url: "/cart/add.js",
        method: "POST",
        payload: { id: t, quantity: a, properties: s },
        error: o,
        complete: r,
        success: async (c) => {
          this.openMiniCart();
          const h = { ...(await this.revalidateCart()) },
            y = h.items.find((m) => m.key === c.key);
          ((h.items_added = [y]),
            Utils.dispatchEvent("cart.items.added", { cart: h, items: [y] }),
            Utils.dispatchEvent("cart.added", { cart: h }),
            Utils.dispatchEvent("cart.updated", { cart: h }),
            i && i(h));
        },
      }));
  },
  addItems({ items: t, success: e, error: s, complete: i, event: o }) {
    this.addToQueue({
      url: "/cart/add.js",
      method: "POST",
      payload: { items: t },
      error: s,
      complete: i,
      success: async ({ items: r }) => {
        this.openMiniCart();
        const a = { ...(await this.revalidateCart()) },
          c = r
            .map((l) => a.items.find((h) => h.key === l.key))
            .filter((l) => !!l);
        ((a.items_added = c),
          Utils.dispatchEvent("cart.items.added", { cart: a, items: c }),
          Utils.dispatchEvent("cart.updated", { cart: a }),
          Utils.dispatchEvent("cart.added", { cart: a }),
          e && e(a));
      },
    });
  },
  removeItem({ line: t, success: e, error: s, complete: i, event: o }) {
    const r = this.cart.items[t - 1];
    this.addToQueue({
      url: "/cart/change.js",
      method: "POST",
      payload: { line: t, quantity: 0 },
      error: s,
      complete: i,
      success: async (n) => {
        const c = { ...(await this.revalidateCart()), items_removed: [r] };
        (Utils.dispatchEvent("cart.items.removed", { cart: c, items: [r] }),
          Utils.dispatchEvent("cart.updated", { cart: c }),
          Utils.dispatchEvent("cart.removed", { cart: c }),
          e && e(c));
      },
    });
  },
  updateItemQuantity({
    line: t,
    quantity: e,
    success: s,
    error: i,
    complete: o,
  }) {
    this.addToQueue({
      url: "/cart/change.js",
      method: "POST",
      payload: { line: t, quantity: e },
      error: i,
      complete: o,
      success: async (r) => {
        const a = {
          ...(await this.revalidateCart()),
          items_added: r.items_added,
          items_removed: r.items_removed,
        };
        (Utils.dispatchEvent("cart.item.quantity.updated", {
          cart: a,
          line: t,
          quantity: e,
        }),
          Utils.dispatchEvent("cart.updated", { cart: a }),
          s && s(a));
      },
    });
  },
  incrementItem({
    line: t,
    quantity: e = 1,
    success: s,
    error: i,
    complete: o,
    event: r,
  }) {
    const n = this.cart.items[t - 1];
    if (!n) {
      (i && i({ message: "Invalid item line number." }),
        console.error("Invalid item line number."));
      return;
    }
    const a = n.quantity + e;
    this.updateItemQuantity({
      line: t,
      quantity: a,
      error: i,
      complete: o,
      success: (c) => {
        (Utils.dispatchEvent("cart.item.quantity.incremented", {
          cart: c,
          item: n,
          line: t,
          quantity: e,
        }),
          s && s(c));
      },
    });
  },
  decrementItem({
    line: t,
    quantity: e = 1,
    success: s,
    error: i,
    complete: o,
    event: r,
  }) {
    const n = this.cart.items[t - 1];
    if (!n) {
      (i && i({ message: "Invalid item line number." }),
        console.error("Invalid item line number."));
      return;
    }
    const a = n.quantity - e;
    a > 0
      ? this.updateItemQuantity({
          line: t,
          quantity: a,
          error: i,
          complete: o,
          success: (c) => {
            (Utils.dispatchEvent("cart.item.quantity.decremented", {
              cart: c,
              item: n,
              line: t,
              quantity: e,
            }),
              s && s(c));
          },
        })
      : this.removeItem({ line: t });
  },
  setCartAttributes({ attributes: t = {}, success: e, error: s, complete: i }) {
    this.addToQueue({
      url: "/cart/update.js",
      method: "POST",
      payload: { attributes: t },
      error: s,
      complete: i,
      success: async (o) => {
        const r = await this.revalidateCart(),
          n = { ...o, ...r };
        (Utils.dispatchEvent("cart.attributes.set", { cart: n, attributes: t }),
          Utils.dispatchEvent("cart.updated", { cart: n }),
          e && e(n));
      },
    });
  },
};
window.Cart = gt;
document.addEventListener("shopify:section:load", function (t) {
  const e = t,
    s = e.detail.sectionId,
    i = e.target.querySelector(`[data-section-id='${s}']`);
  i != null && i.onSectionLoad && i.onSectionLoad(e);
});
document.addEventListener("shopify:section:unload", function (t) {
  const e = t,
    s = e.detail.sectionId,
    i = e.target.querySelector(`[data-section-id='${s}']`);
  i != null && i.onSectionUnload && i.onSectionUnload(e);
});
document.addEventListener("shopify:section:select", function (t) {
  const e = t,
    s = e.detail.sectionId,
    i = e.target.querySelector(`[data-section-id='${s}']`);
  i != null && i.onSectionSelect && i.onSectionSelect(e);
});
document.addEventListener("shopify:section:deselect", function (t) {
  const e = t,
    s = e.detail.sectionId,
    i = e.target.querySelector(`[data-section-id='${s}']`);
  i != null && i.onSectionDeselect && i.onSectionDeselect(e);
});
document.addEventListener("shopify:block:select", function (t) {
  const e = t,
    s = e.detail.sectionId,
    i = e.target.querySelector(`[data-section-id='${s}']`);
  i != null && i.onBlockSelect && i.onBlockSelect(e);
});
document.addEventListener("shopify:block:deselect", function (t) {
  const e = t,
    s = e.detail.sectionId,
    i = e.target.querySelector(`[data-section-id='${s}']`);
  i != null && i.onBlockDeselect && i.onBlockDeselect(e);
});
Vue.directive("lazysizes", {
  bind(t, e, s) {
    if (s.tag !== "img" && s.tag !== "video")
      throw new Error(
        `${s.tag} is wrong element, use img or video element instead`,
      );
    t.classList.add("lazyload");
  },
  update(t, e, s, i) {
    const {
        data: {
          attrs: { "data-src": o },
        },
      } = s,
      {
        data: {
          attrs: { "data-src": r },
        },
      } = i;
    o !== r && (t.classList.remove("lazyloaded"), t.classList.add("lazyload"));
  },
});
Vue.directive("video-lazysizes", {
  bind(t, e, s) {
    if (s.tag !== "video")
      throw new Error(`${s.tag} is wrong element, use video element instead`);
    t.classList.add("lazyload");
  },
  update(t, e, s, i) {
    const {
        data: {
          attrs: { "data-src": o },
        },
      } = s,
      {
        data: {
          attrs: { "data-src": r },
        },
      } = i;
    o !== r &&
      (t.classList.remove("lazyloaded", "lazyloading"),
      t.classList.add("lazyload"));
  },
});
Vue.filter("upcase", Utils.upcase);
Vue.filter("resize_image", Utils.resizeImage);
Vue.filter("resize_image_srcset", Utils.resizeImageSrcset);
Vue.filter("product_title", Utils.productName);
Vue.filter("product_colorname", Utils.productColorname);
Vue.filter("pluralize", Utils.pluralize);
Vue.filter("money", Utils.money);
Vue.filter("cents", Utils.toCents);
Vue.filter("handleize", Utils.handleize);
Vue.filter("filename", Utils.filename);
Vue.filter("ceil", Math.ceil);
Vue.filter("floor", Math.floor);
Vue.config.ignoredElements = [/^my-/, /^section-/, /^vue-/];
Vue.mixin({
  delimiters: ["${", "}"],
  data() {
    return {
      hydrated: !1,
      MQ,
      Cart,
      Theme,
      RVP: Utils.getFromLocalStorage("recently_viewed_products", []),
      RECENT_QUERIES: Utils.getFromLocalStorage("recent_queries", []),
    };
  },
  created() {
    const t = this.$options.name || "";
    t.startsWith("vue-") &&
      Utils.dispatchEvent(`vue-created.${t}`, { vue_instance: this });
  },
  mounted() {
    const t = this.$options.name || "";
    if (t.startsWith("vue-")) {
      Utils.dispatchEvent(`vue-mounted.${t}`, { vue_instance: this });
      const e = this.$el;
      e &&
        e instanceof HTMLElement &&
        (e.setAttribute("data-vue-parent", ""),
        e.setAttribute("data-hydrated", ""),
        (this.hydrated = !0));
    }
  },
  watch: {
    RVP(t, e) {
      if (t !== e)
        try {
          localStorage.setItem("recently_viewed_products", JSON.stringify(t));
        } catch {}
    },
    RECENT_QUERIES(t, e) {
      if (t !== e)
        try {
          localStorage.setItem("recent_queries", JSON.stringify(t));
        } catch {}
    },
  },
  methods: {},
});
function S() {
  window.quicklink.listen({
    ignores: [
      /\/cart/,
      /\/checkout/,
      /\/account/,
      /\/customer_authentication/,
      /\/search/,
      /\/password/,
      /\/challenge/,
      /\/gift_cards\//,
      /\.(pdf|zip|xml|csv|xls|xlsx|doc|docx)$/i,
      /[?&]preview_theme_id=/,
      /\/admin/,
      (t) =>
        t.includes("logout") ||
        t.includes("#") ||
        t.startsWith("mailto:") ||
        t.startsWith("tel:") ||
        t.startsWith("javascript:"),
      (t, e) =>
        e.hasAttribute("noprefetch") ||
        e.hasAttribute("data-noprefetch") ||
        e.hasAttribute("download") ||
        e.getAttribute("target") === "_blank",
    ],
  });
}
window.addEventListener("load", () => {
  S();
  const t = Utils.debounce(S, 300);
  new MutationObserver((e) => {
    var i, o;
    let s = !1;
    for (const r of e) {
      for (const n of Array.from(r.addedNodes))
        if (
          !(n.nodeType !== 1 || !(n instanceof Element)) &&
          (((i = n.matches) != null && i.call(n, "a[href]")) ||
            ((o = n.querySelector) != null && o.call(n, "a[href]")))
        ) {
          s = !0;
          break;
        }
      if (s) break;
    }
    s && t();
  }).observe(document.body, { childList: !0, subtree: !0 });
});
class wt extends HTMLElement {
  constructor() {
    (super(),
      (this.hide = this.hide.bind(this)),
      (this.hideIfPersisted = this.hideIfPersisted.bind(this)),
      (this.show = this.show.bind(this)),
      (this.onLinkClick = this.onLinkClick.bind(this)));
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.kill();
  }
  init() {
    this.attachEventHandlers();
  }
  kill() {
    this.removeEventHandlers();
  }
  hide() {
    this.setAttribute("data-close", "");
  }
  hideIfPersisted(e) {
    e.persisted && this.hide();
  }
  show() {
    this.removeAttribute("data-close");
  }
onLinkClick(e) {
  const t = e.target.closest("a[href]");
  if (!t) return;
  const n = t.getAttribute("href") || "";
  if (
    n.startsWith("mailto:") ||
    n.startsWith("tel:") ||
    n.startsWith("javascript:") ||
    n.startsWith("#") ||
    (n.includes("#") &&
      new URL(n, window.location.origin).pathname ===
        window.location.pathname) ||
    t.hasAttribute("download") ||
    t.getAttribute("target") === "_blank"
  )
    return;
  
  // Check if link is external (different hostname)
  try {
    const linkUrl = new URL(n, window.location.origin);
    if (linkUrl.hostname !== window.location.hostname) {
      t.setAttribute("target", "_blank");
      t.setAttribute("rel", "noopener noreferrer");
      return;
    }
  } catch (err) {
    // Invalid URL, let it proceed normally
  }
  
  this.show();
}
  attachEventHandlers() {
    (document.addEventListener("DOMContentLoaded", this.hide),
      document.addEventListener("click", this.onLinkClick),
      window.addEventListener("pageshow", this.hideIfPersisted),
      window.addEventListener("submit", this.show));
  }
  removeEventHandlers() {
    (document.removeEventListener("DOMContentLoaded", this.hide),
      document.removeEventListener("click", this.onLinkClick),
      window.removeEventListener("pageshow", this.hideIfPersisted),
      window.removeEventListener("submit", this.show));
  }
}
customElements.define("my-page-transition", wt);
class vt extends HTMLElement {
  constructor() {
    (super(),
      (this.vue_instance = null),
      (this._props = null),
      (this.threshold = null),
      (this.prev_scroll = {
        top: window.scrollY || document.documentElement.scrollTop,
        direction: "",
      }));
  }
  static get observedAttributes() {
    return ["props"];
  }
  attributeChangedCallback(e, s, i) {
    e !== "props" || s === i || (this.props = i);
  }
  get props() {
    return this._props;
  }
  set props(e) {
    this.props !== e &&
      ((this._props = typeof e == "string" ? Utils.parseJSON(e, null) : e),
      this._props && this.update());
  }
  disconnectedCallback() {
    this.kill();
  }
  connectedCallback() {
    this.init();
  }
  init() {}
  update() {
    var e, s, i, o;
    this.threshold = null;
    this.setAttribute("data-type", this.props?.type ?? "fill");
    if (
      (s = (e = this.props) == null ? void 0 : e.type) != null &&
      s.startsWith("transparent")
    ) {
      const r = document.querySelector(
        "main > section:first-child [data-fullbleed]",
      );
      r && (this.threshold = r.offsetHeight);
    }
    this.vue_instance
      ? (o = (i = this.vue_instance) == null ? void 0 : i.init) == null ||
        o.call(i)
      : this.createVueInstance();
  }
  kill() {
    (this.destroyVueInstance(),
      (this.vue_instance = null),
      (this.props = null));
  }
  destroyVueInstance() {
    var e;
    (e = this.vue_instance) == null || e.$destroy();
  }
  createVueInstance() {
    const e = this;
    this.vue_instance = new Vue({
      name: `vue-${e.tagName.toLowerCase()}`,
      data() {
        return {
          props: null,
          active_parent_link: Utils.getFromLocalStorage(
            "active_parent_link",
            null,
          ),
          hovered_link: null,
        };
      },
      created() {
        this.init();
      },
      mounted() {
        this.$nextTick(() => this.setCSSVariables());
      },
      beforeDestroy() {
        this.kill();
      },
      watch: {
        active_parent_link(s) {
          s &&
            localStorage.active_parent_link !== s &&
            (localStorage.active_parent_link = s);
        },
      },
      methods: {
        init() {
          if (typeof e.props == "string" || !e.props)
            return console.error("No props found");
          (this.reset(),
            (this.props = e.props),
            window.addEventListener("scroll", this.scrollHandler),
            document.addEventListener("resize.width", this.setCSSVariables));
        },
        kill() {
          (window.removeEventListener("scroll", this.scrollHandler),
            document.removeEventListener("resize.width", this.setCSSVariables),
            this.reset());
        },
        reset() {
          ((this.hovered_link = null), (this.props = null));
        },
        setCSSVariables() {
          var s, i, o;
          (document.documentElement.style.setProperty(
            "--nav-top-container-height",
            `${((s = this.$refs["announcement-bar"]) == null ? void 0 : s.offsetHeight) ?? 0}px`,
          ),
            document.documentElement.style.setProperty(
              "--nav-main-container-height",
              `${((i = this.$refs.navbar) == null ? void 0 : i.offsetHeight) ?? 0}px`,
            ),
            document.documentElement.style.setProperty(
              "--nav-height",
              `${((o = this.$refs.nav) == null ? void 0 : o.offsetHeight) ?? 0}px`,
            ));
        },
        scrollHandler() {
          var i, o, r;
          const s = window.scrollY || document.documentElement.scrollTop;
          if (
            (o = (i = this.props) == null ? void 0 : i.type) != null &&
            o.startsWith("transparent")
          ) {
            const n =
              e.threshold &&
              e.threshold -
                ((r = this.$refs.nav) == null ? void 0 : r.offsetHeight);
            if (!n) return;
            (document.documentElement.setAttribute(
              "data-past-threshold",
              s > n ? "true" : "false",
            ),
              e.setAttribute("data-type", s > n ? "fill" : this.props.type));
          }
          (s > e.prev_scroll.top && e.prev_scroll.direction !== "down"
            ? ((e.prev_scroll.direction = "down"),
              document.documentElement.setAttribute(
                "data-scroll-direction",
                "down",
              ))
            : s < e.prev_scroll.top &&
              e.prev_scroll.direction !== "up" &&
              ((e.prev_scroll.direction = "up"),
              document.documentElement.setAttribute(
                "data-scroll-direction",
                "up",
              )),
            (e.prev_scroll.top = s <= 0 ? 0 : s));
        },
      },
    }).$mount(this.querySelector("[data-vue-root]"));
  }
}
customElements.define("section-navbar", vt);
const Et = "vue-product-card";
Vue.component(Et, {
  props: {
    product: { type: Object, required: !0 },
    index: { type: Number },
    source: { type: String },
  },
  data() {
    return {
      selected_colorway_id: this.product.id,
      colorways: [this.product, ...this.product.colorways.filter((c) => c.id !== this.product.id)],
      has_interacted: !1,
      vt: !1,
      loading_colorways: !1,
      active_image_index: 0,
    };
  },
  computed: {
    active_colorway() {
      const t = this.colorways.find((e) => e.id === this.selected_colorway_id);
      return t || this.product;
    },
    active_colorway_index() {
      return this.colorways.findIndex(
        (t) => t.id === this.selected_colorway_id,
      );
    },
    product_images() {
      var t;
      return (
        ((t = this.active_colorway) == null ? void 0 : t.images.slice(1)) ?? []
      );
    },
    image_size() {
      var t, e;
      return (e = (t = this.MQ) == null ? void 0 : t["till-phone"]) != null &&
        e.matches
        ? "400x"
        : "800x";
    },
  },
  beforeDestroy() {
    this.colorways = [];
  },
  methods: {
    changeImage(t) {
      t == "forward"
        ? (this.active_image_index =
            (this.active_image_index + 1) % this.active_colorway.images.length)
        : t == "backward" &&
          (this.active_image_index =
            (this.active_image_index - 1 + this.active_colorway.images.length) %
            this.active_colorway.images.length);
    },
    resetImageTracker() {
      this.active_image_index = 0;
    },
    imageMover() {
      (this.has_interacted || (this.has_interacted = !0),
        this.product_images.length > 1 && (this.active_image_index = 1));
    },
    imageScroller() {
      this.has_interacted || (this.has_interacted = !0);
    },
    async prefetchColorways() {
      this.product.sid &&
        (await window.Utils.fetchColorways({
          sid: this.product.sid,
          exclude: this.product.id,
        }));
    },
    async changeColorway(t) {
      var o;
      if (
        this.loading_colorways ||
        !this.product.sid ||
        t.id === ((o = this.active_colorway) == null ? void 0 : o.id)
      )
        return;
      if (t.hasOwnProperty("variants")) {
        this.selected_colorway_id = t.id;
        return;
      }
      this.loading_colorways = !0;
      const { colorways: s, error: i } = await window.Utils.fetchColorways({
        sid: this.product.sid,
        exclude: this.product.id,
      });
      if (i || !s) {
        (console.error(i ?? "No colorways found"),
          (this.loading_colorways = !1));
        return;
      }
      ((this.colorways = [
        this.product,
        ...this.product.colorways
          .map((r) => s.find((n) => n.id === r.id))
          .filter((r) => !!r),
      ]),
        (this.selected_colorway_id = t.id),
        (this.loading_colorways = !1));
    },
    showQuickView() {
      (this.active_colorway.images.length &&
        Utils.startViewTransitionPDP(this.$el),
        Utils.bridgify.wc(
          "my-modal[name='product-quick-view'] section-pdp",
          "section-pdp",
          ({ web_component: t }) => {
            t.props = { mode: "colorway", colorway: this.active_colorway };
          },
        ));
    },
    showBIS(t) {
      Utils.bridgify.wc(
        "my-modal[name='back-in-stock'] section-bis-klaviyo",
        "section-bis-klaviyo",
        ({ web_component: e }) => {
          e.props = { product: this.active_colorway, selected_variant_id: t };
        },
      );
    },
  },
});
document.addEventListener("click", (t) => {
  var s;
  const e = (s = t.target) == null ? void 0 : s.closest("[data-open-modal]");
  if (e) {
    const i = e.getAttribute("data-open-modal"),
      o = document.querySelector(`my-modal[name="${i}"]`);
    o && o.open();
  }
});
class bt extends HTMLElement {
  constructor() {
    (super(),
      (this.name = null),
      (this.direction = "down"),
      (this.start_x = 0),
      (this.start_y = 0),
      (this.current_x = 0),
      (this.current_y = 0),
      (this.threshold = 100),
      (this.is_swiping = !1),
      (this.has_moved = !1),
      (this.sheet = null),
      (this.open = this.open.bind(this)),
      (this.close = this.close.bind(this)),
      (this.onTouchStart = this.onTouchStart.bind(this)),
      (this.onTouchMove = this.onTouchMove.bind(this)),
      (this.onTouchEnd = this.onTouchEnd.bind(this)),
      (this.onEscapeKey = this.onEscapeKey.bind(this)),
      (this.onTabKey = this.onTabKey.bind(this)),
      (this.onCloserClick = this.onCloserClick.bind(this)));
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.kill();
  }
  init() {
    ((this.name = this.getAttribute("name")),
      (this.direction = this.getAttribute("data-direction") ?? "down"),
      (this.start_x = 0),
      (this.start_y = 0),
      (this.current_x = 0),
      (this.current_y = 0),
      (this.threshold = parseInt(this.getAttribute("data-threshold") ?? "100")),
      (this.is_swiping = !1),
      (this.has_moved = !1),
      (this.sheet = this.querySelector("[data-sheet]")),
      this.attachEventListeners());
  }
  kill() {
    (this.detachEventListeners(),
      (this.name = null),
      (this.start_x = 0),
      (this.start_y = 0),
      (this.current_x = 0),
      (this.current_y = 0),
      (this.threshold = 100),
      (this.is_swiping = !1),
      (this.has_moved = !1),
      (this.sheet = null));
  }
  attachEventListeners() {
    var e, s, i;
    (this.addEventListener("click", this.onCloserClick),
      (e = this.sheet) == null ||
        e.addEventListener("touchstart", this.onTouchStart),
      (s = this.sheet) == null ||
        s.addEventListener("touchmove", this.onTouchMove),
      (i = this.sheet) == null ||
        i.addEventListener("touchend", this.onTouchEnd),
      document.addEventListener("keydown", this.onEscapeKey),
      this.addEventListener("keydown", this.onTabKey));
  }
  detachEventListeners() {
    var e, s, i;
    (this.removeEventListener("click", this.onCloserClick),
      (e = this.sheet) == null ||
        e.removeEventListener("touchstart", this.onTouchStart),
      (s = this.sheet) == null ||
        s.removeEventListener("touchmove", this.onTouchMove),
      (i = this.sheet) == null ||
        i.removeEventListener("touchend", this.onTouchEnd),
      document.removeEventListener("keydown", this.onEscapeKey),
      this.removeEventListener("keydown", this.onTabKey));
  }
  open() {
    var e;
    // iOS-safe scroll lock: save position and pin body via top offset
    if (!document.documentElement.getAttribute("data-open-modals")) {
      this._scrollY = window.scrollY || document.documentElement.scrollTop;
      document.body.style.setProperty("top", `-${this._scrollY}px`);
      document.body.style.setProperty("position", "fixed");
      document.body.style.setProperty("width", "100%");
    }
    (this.setAttribute("open", ""),
      this.setAttribute("role", "dialog"),
      this.setAttribute("aria-modal", "true"),
      this.name && !this.getAttribute("aria-label") &&
        this.setAttribute("aria-label", this.name.replace(/-/g, " ")),
      this.name &&
        (Utils.dispatchEvent(`my-modal.opened.${this.name}`, { modal: this }),
        document.documentElement.setAttribute(
          `data-open-modal-${this.name}`,
          "",
        ),
        document.documentElement.setAttribute(
          "data-open-modals",
          [
            ...(((e =
              document.documentElement.getAttribute("data-open-modals")) == null
              ? void 0
              : e.split(",")) || []),
            this.name,
          ]
            .filter(Boolean)
            .join(","),
        )));
    this._previouslyFocused = document.activeElement;
    requestAnimationFrame(() => {
      const focusable = this.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length) focusable[0].focus();
    });
  }
  close() {
    const _prev = this._previouslyFocused;
    if (
      (this.removeAttribute("open"),
      setTimeout(() => {
        var e, s, i, o;
        ((e = this.closest("[data-scroller]")) == null || e.scrollTo(0, 0),
          (s = this.sheet) == null || s.style.removeProperty("transition"),
          (i = this.sheet) == null ||
            i.style.removeProperty("--tw-translate-y"),
          (o = this.sheet) == null ||
            o.style.removeProperty("--tw-translate-x"));
      }, 200),
      this.name)
    ) {
      (Utils.dispatchEvent(`my-modal.closed.${this.name}`, { modal: this }),
        document.documentElement.removeAttribute(
          `data-open-modal-${this.name}`,
        ));
      const s = (
        document.documentElement.getAttribute("data-open-modals") || ""
      )
        .split(",")
        .filter(Boolean)
        .filter((i) => i !== this.name);
      if (s.length === 0) {
        // All modals closed — restore scroll position (iOS-safe unlock)
        const scrollY = this._scrollY || parseInt(document.body.style.top || "0", 10) * -1;
        document.body.style.removeProperty("position");
        document.body.style.removeProperty("top");
        document.body.style.removeProperty("width");
        window.scrollTo({ top: scrollY, behavior: "instant" });
        document.documentElement.removeAttribute("data-open-modals");
      } else {
        document.documentElement.setAttribute("data-open-modals", s.join(","));
      }
    }
    if (_prev && typeof _prev.focus === "function") {
      setTimeout(() => _prev.focus(), 50);
    }
  }
  onEscapeKey(e) {
    if (e.key !== "Escape") return;
    const i = (document.documentElement.getAttribute("data-open-modals") || "")
      .split(",")
      .filter(Boolean);
    i.length > 0 && i[i.length - 1] === this.name && this.close();
  }
  onTabKey(e) {
    if (e.key !== "Tab") return;
    const focusable = Array.from(this.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(el => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
  onCloserClick(e) {
    var i, o;
    if ((i = e.target) == null ? void 0 : i.closest("[data-close]")) {
      e.preventDefault();
      const r = (o = e.target) == null ? void 0 : o.closest("my-modal");
      if (r && r !== this) return;
      this.close();
    }
  }
  onTouchStart(e) {
    ((this.has_moved = !1),
      this.isSafeToStartSwiping(e.target)
        ? ((this.current_x = 0),
          (this.current_y = 0),
          (this.start_x = e.touches[0].clientX),
          (this.start_y = e.touches[0].clientY),
          (this.is_swiping = !0))
        : (this.is_swiping = !1));
  }
  onTouchMove(e) {
    if (!this.is_swiping || !this.sheet) return;
    ((this.current_x = e.touches[0].clientX),
      (this.current_y = e.touches[0].clientY),
      (this.has_moved = !0));
    const s = this.current_x - this.start_x,
      i = this.current_y - this.start_y,
      o = this.direction,
      r = (Math.atan2(Math.abs(i), Math.abs(s)) * 180) / Math.PI,
      n = r > 45,
      a = r <= 45;
    o === "down" && n && i > 0
      ? (e.preventDefault(),
        (this.sheet.style.transition = "none"),
        this.sheet.style.setProperty("--tw-translate-y", `${i}px`))
      : o === "right" && a && s > 0
        ? (e.preventDefault(),
          (this.sheet.style.transition = "none"),
          this.sheet.style.setProperty("--tw-translate-x", `${s}px`))
        : o === "left" &&
          a &&
          s < 0 &&
          (e.preventDefault(),
          (this.sheet.style.transition = "none"),
          this.sheet.style.setProperty("--tw-translate-x", `${s}px`));
  }
  onTouchEnd() {
    if (!this.is_swiping || !this.sheet || !this.has_moved) return;
    const e = this.current_x - this.start_x,
      s = this.current_y - this.start_y,
      i = this.threshold,
      o = this.direction;
    this.is_swiping = !1;
    const r = (Math.atan2(Math.abs(s), Math.abs(e)) * 180) / Math.PI,
      n = r > 45,
      a = r <= 45;
    (o === "down"
      ? s > i && n
        ? (this.sheet.style.setProperty("--tw-translate-y", "100%"),
          setTimeout(() => this.close(), 100))
        : this.sheet.style.setProperty("--tw-translate-y", "0")
      : o === "right"
        ? e > i && a
          ? (this.sheet.style.setProperty("--tw-translate-x", "100%"),
            setTimeout(() => this.close(), 100))
          : this.sheet.style.setProperty("--tw-translate-x", "0")
        : o === "left" &&
          (-e > i && a
            ? (this.sheet.style.setProperty("--tw-translate-x", "-100%"),
              setTimeout(() => this.close(), 100))
            : this.sheet.style.setProperty("--tw-translate-x", "0")),
      this.sheet.style.removeProperty("transition"));
  }
  isSafeToStartSwiping(e) {
    const s = e.closest("[data-scroller]");
    return s
      ? e.closest(".swiper-slide-zoomed") || e.closest("[data-ignore-swipe]")
        ? !1
        : this.direction === "right"
          ? s.scrollLeft === 0
          : this.direction === "left"
            ? s.scrollLeft === s.scrollWidth - s.clientWidth
            : s.scrollTop === 0
      : !0;
  }
}
customElements.define("my-modal", bt);
